import React from "react";
import { makeStyles } from "@material-ui/core";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import TrendingDownIcon from "@material-ui/icons/TrendingDown";

const useStyles = makeStyles(() => ({
  "@keyframes fadeInUp": {
    from: { opacity: 0, transform: "translateY(8px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  container: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    "@media (max-width: 480px)": {
      flexDirection: "column",
    },
  },
  // Adaptive: 2 cards get wider so they fill the row
  containerTwo: {
    "& $card": {
      flex: "1 1 200px",
      maxWidth: "340px",
    },
  },
  card: {
    borderRadius: "10px",
    padding: "16px 18px",
    minWidth: "140px",
    flex: "1 1 160px",
    maxWidth: "240px",
    borderTop: "3px solid #E8EBF0",
    borderLeft: "none",
    border: "1px solid #E8EBF0",
    borderTopWidth: "3px",
    background: "rgba(255,255,255,0.9)",
    animation: "$fadeInUp 200ms ease-out both",
    transition: "transform 150ms ease-out, box-shadow 150ms ease-out",
    cursor: "default",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
    },
  },
  cardUnfavorableDown: {
    borderTopColor: "#dc2626",
  },
  cardUnfavorableNeutral: {
    borderTopColor: "#d97706",
  },
  cardFavorable: {
    borderTopColor: "#059669",
  },
  cardDefault: {
    borderTopColor: "#E8EBF0",
  },
  label: {
    fontSize: "10.5px",
    textTransform: "uppercase",
    color: "#6b7280",
    letterSpacing: "0.5px",
    fontWeight: 500,
    marginBottom: "4px",
    fontFamily: "'DM Sans', sans-serif",
  },
  value: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#111827",
    fontVariantNumeric: "tabular-nums",
    letterSpacing: "-0.5px",
    fontFamily: "'IBM Plex Mono', monospace",
  },
  change: {
    fontSize: "11.5px",
    marginTop: "4px",
    display: "flex",
    alignItems: "center",
    gap: "3px",
    fontWeight: 500,
    fontFamily: "'IBM Plex Sans', sans-serif",
  },
  changeFavorable: {
    color: "#16a34a",
  },
  changeUnfavorable: {
    color: "#dc2626",
  },
}));

const MetricCards = React.memo(function MetricCards({ metrics }) {
  var classes = useStyles();

  if (!metrics || !metrics.length) return null;

  function getCardClass(m) {
    if (m.is_favorable === false && m.direction === "down") return classes.cardUnfavorableDown;
    if (m.is_favorable === false && (!m.direction || m.direction === "")) return classes.cardUnfavorableNeutral;
    if (m.is_favorable) return classes.cardFavorable;
    return classes.cardDefault;
  }

  var containerClass = classes.container + (metrics.length === 2 ? " " + classes.containerTwo : "");

  return (
    <div className={containerClass}>
      {metrics.map(function (m, i) {
        return (
          <div
            key={i}
            className={classes.card + " " + getCardClass(m)}
            style={{ animationDelay: (120 + 40 * i) + "ms" }}
          >
            <div className={classes.label}>{m.label}</div>
            <div className={classes.value}>{m.value}</div>
            {m.change && (
              <div
                className={
                  classes.change + " " +
                  (m.is_favorable ? classes.changeFavorable : classes.changeUnfavorable)
                }
              >
                {m.direction === "up" ? (
                  <TrendingUpIcon style={{ fontSize: 14 }} />
                ) : m.direction === "down" ? (
                  <TrendingDownIcon style={{ fontSize: 14 }} />
                ) : null}
                {m.change}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
});

export default MetricCards;
